export default __webpack_public_path__ + "static/media/binance.20a39117.svg";